import React from 'react'

const AccessDenied = props => {
  return (
    <div className='animated fadeIn'> 
      <h4> 404 Not Found </h4>
    </div>
  )
}

export default AccessDenied


// WEBPACK FOOTER //
// ./src/views/404/404.js